var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.994,
    height: 14.311,
    viewBox: "0 0 8.994 14.311",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#656565;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.123,131.779l-6.241-6.241a.771.771,0,0,1,0-1.09l.728-.728a.771.771,0,0,1,1.089,0l4.969,4.946,4.969-4.946a.771.771,0,0,1,1.089,0l.728.728a.771.771,0,0,1,0,1.09l-6.241,6.241a.771.771,0,0,1-1.09,0Z",
    transform: "matrix(-0.035, 0.999, -0.999, -0.035, 132.611, -1.046)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.7cd5c820ac55a4f842b3e149a85679eb.svg";